import { ActionTree } from 'vuex'
import { Persons } from './types'
import { RootState } from '../types'
import { PersonsHelpers } from '@/helpers/mainExports.js'
import { i18n } from '@leapsight/portal'

export const actions: ActionTree<Persons, RootState> = {
  getThingsAssignmentList({ commit, dispatch }, { uriId }) {
    return new Promise((resolve, reject) => {
      PersonsHelpers.thingAssignmentsGet(uriId)
        .then(res => {
          const thingsAssignments = res
          commit('setThingsAssignments', { uriId, thingsAssignments })
          resolve(thingsAssignments)
        })
        .catch(err => {
          dispatch('setResponseError', true)
          if (err.error == 'com.magenta.error.operation_not_allowed') {
            const response = i18n.t(
              'fleet_management.persons.persons_tab_all.errors.no_permission'
            )
            dispatch('setResponseMessage', response)
          } else {
            const response = i18n.t(
              'fleet_management.persons.persons_tab_all.errors.other_error'
            )
            dispatch('setResponseMessage', response)
          }
          reject(err)
        })
    })
  },
  getPersonsList({ dispatch }) {
    return new Promise(resolve => {
      PersonsHelpers.getPersonsList()
        .then(response => {
          dispatch('setResponseError', false)
          if (response.args.length > 0) {
            const persons = response.args[0]
            dispatch('setPersons', persons)
            resolve(persons)
          }
        })
        .catch(error => {
          dispatch('setResponseError', true)
          if (error.error == 'com.magenta.error.operation_not_allowed') {
            const response = i18n.t(
              'fleet_management.persons.persons_tab_all.errors.no_permission'
            )
            dispatch('setResponseMessage', response)
          } else {
            const response = i18n.t(
              'fleet_management.persons.persons_tab_all.errors.other_error'
            )
            dispatch('setResponseMessage', response)
          }
        })
    })
  },
  setPersons({ state, commit, dispatch }, payload) {
    // commit('cleanPersonsState')
    if (payload.length > 0) {
      payload.forEach(person => {
        const id = PersonsHelpers.getPersonId(person)
        const created_by = person.created_by
        const uriId = person.id
        const first_name = person.first_name
        const last_name = person.last_name
        const account_id = person.account_id
        const identification_number = person.identification_number ?? ''
        const identification_type = person.identification_type ?? ''
        const fullName = `${person.first_name} ${person.last_name}`
        const roles = PersonsHelpers.getRoles(person)
        const phones = PersonsHelpers.getPhones(person)
        const emails = PersonsHelpers.getPersonEmail(person)
        const profile = PersonsHelpers.getProfile(person)
        const ibutton = PersonsHelpers.getIbutton(person)

        const dataPerson = {
          id,
          created_by,
          uriId,
          first_name,
          last_name,
          fullName,
          phones,
          account_id,
          roles,
          emails,
          profile,
          identification_number,
          identification_type,
          ...(ibutton !== null && { ibutton })
        }
        commit('setPersons', dataPerson)
      })
    }
    commit('resetFilterPersonsState')
  },
  setPerson({ commit }, payload) {
    const id = PersonsHelpers.getPersonId(payload)
    const created_by = payload.created_by
    const uriId = payload.id
    const first_name = payload.first_name
    const last_name = payload.last_name
    const account_id = payload.account_id
    const identification_number = payload.identification_number ?? ''
    const identification_type = payload.identification_type ?? ''
    const fullName = `${payload.first_name} ${payload.last_name}`
    const roles = PersonsHelpers.getRoles(payload)
    const phones = PersonsHelpers.getPhones(payload)
    const email = PersonsHelpers.getPersonEmail(payload)
    const emails = PersonsHelpers.getPersonEmail(payload)
    const profile = PersonsHelpers.getProfile(payload)
    const ibutton = PersonsHelpers.getIbutton(payload)

    const dataPerson = {
      id,
      created_by,
      uriId,
      first_name,
      last_name,
      fullName,
      phones,
      account_id,
      roles,
      email,
      emails,
      profile,
      identification_number,
      identification_type,
      ...(ibutton !== null && { ibutton })
    }
    commit('setPersons', dataPerson)
  },
  setCurrentPerson({ commit }, payload) {
    return new Promise<void>(resolve => {
      commit('setCurrentPerson', payload)
      resolve()
    })
  },
  setTotalPersons({ commit }, data) {
    commit('setTotalPersons', data)
  },
  setResponseError({ commit }, payload) {
    commit('setResponseError', payload)
  },

  setResponseMessage({ commit }, message) {
    commit('setResponseMessage', message)
  },
  resetPersonsState({ commit }) {
    commit('resetPersonsState')
  },
  updatePerson(
    { commit },
    {
      uriId,
      firstName,
      lastName,
      identifyType,
      identifyNumber,
      phonesIn,
      ibutton
    }
  ) {
    commit('updatePerson', {
      uriId,
      firstName,
      lastName,
      identifyType,
      identifyNumber,
      phonesIn,
      ibutton
    })
  },
  updatePersonRol({ commit }, { roles, profile, phones, ibutton }) {
    commit('updatePersonRol', {
      roles,
      profile,
      phones,
      ibutton
    })
  },
  filterPersonsByString({ state, commit }, { string }) {
    if (string.length > 1) {
      const filterPersons = state.persons.filter(
        (person: any) =>
          person.fullName.toLowerCase().match(string) ||
          person.email?.some((e: any) => e.email.toLowerCase().match(string))
      )
      commit('setFilterPersonsByString', { filterPersons })
    } else commit('resetFilterPersonsState')
  }
}
